import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Selects the whole value of a `currencyMask` (ngx-currency) input when it gains focus.
 *
 * ngx-currency runs in "Natural" input mode across the app. In that mode a digit typed
 * while the caret sits after the last decimal place is discarded, so a user who tabs or
 * clicks into "$ 0.00" and starts typing sees nothing happen. Selecting the existing
 * value on focus means the first keystroke replaces it and the caret is placed at the
 * decimal separator, which is the behaviour users expect from a money field.
 *
 * Applies automatically to every `<input currencyMask>`. Add `noSelectOnFocus` to opt out.
 */
@Directive({
  selector: 'input[currencyMask]:not([noSelectOnFocus])',
  standalone: true
})
export class CurrencySelectOnFocusDirective {
  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('focus')
  onFocus(): void {
    const input = this.el.nativeElement;
    // Defer so the browser's own caret placement (mouse click) has already happened.
    setTimeout(() => {
      if (document.activeElement === input) {
        input.select();
      }
    }, 0);
  }
}
